/**
 * Utility-method used to log information to the client / developer console.
 *
 * Accepts either a plain string or a zero-argument factory function as the
 * message argument. Using a factory defers evaluation (e.g. JSON.stringify)
 * so the cost is only paid when the log will actually be output:
 *
 *   clientLog('debug', () => 'data: ' + JSON.stringify(heavyObject), 'myComp');
 *
 * @param {'info'|'debug'|'error'|'warn'|'warning'} logType
 * @param {string|function(): string} messageOrFactory  Message string, or a
 *   zero-argument factory that returns the message string.
 * @param {string|null} component  Optional component name for the log prefix.
 */
export const clientLog = (logType, messageOrFactory, component = null) => {
    // Suppress debug-level logs in production to avoid the overhead of string
    // interpolation and JSON serialisation in hot paths (reducers, render fns…).
    if (logType === 'debug' && process.env.NODE_ENV === 'production') {
        return;
    }

    if (logType === 'warning') {
        logType = 'warn';
    }

    // Evaluate the message lazily when a factory function is provided.
    const message = typeof messageOrFactory === 'function' ? messageOrFactory() : messageOrFactory;

    const prefix = '[DAMS]';
    const componentPrefix = component !== null ? `[${component}]` : '';
    const logMessage = `${prefix}${componentPrefix} - ${message}`;
    console[logType](logMessage);
};

